// extracted by mini-css-extract-plugin
module.exports = {"Status":"Status_Status__gIn1L","Blue":"Status_Blue__jkxG3","Yellow":"Status_Yellow__3Jtbe","Orange":"Status_Orange__Ud47E","Green":"Status_Green__1WBQL","Red":"Status_Red__2WPZD"};